define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    var dlgClass = 'add-to-cart-dialog';
    function default_1() {
        var $dlg = $("." + dlgClass);
        if ($dlg.length === 0) {
            $dlg = $("<div class=\"" + dlgClass + "\"><h3 class=\"title\">Item added to cart</h3><button class=\"view-cart\">View cart</button><div class=\"ruler\"><span>or</span><hr/></div><button class=\"continue-shop\">Continue shopping</button></div>");
            $dlg.appendTo($('body'));
            $dlg.find('.view-cart').click(function () {
                $dlg.dialog('close');
                window.location.href = '/cart';
            });
            $dlg.find('.continue-shop').click(function (evt) {
                $dlg.dialog('close');
            });
        }
        $dlg.dialog('show');
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/addToCartSuccess.js
// module id = 30
// module chunks = 0